import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { StudentModel } from 'src/app/models/StudentModel';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { DropdownDialogComponent } from '../dropdown-dialog/dropdown-dialog.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FileDownloadService } from 'src/app/services/FileDownload.service';
import { CommonConstant, NoRecordFound } from 'src/app/constants/common-constant';
import { StudentLableConstant } from 'src/app/constants/label-constants';
import { StatusDialogboxComponent } from '../status-dialogbox/status-dialogbox.component';
import { StudentAddComponent } from './student-add/student-add.component';
import * as saveAs from 'file-saver';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { StudentViewComponent } from './student-view/student-view.component';
import { DeleteDialogboxComponent } from '../delete-dialogbox/delete-dialogbox.component';
interface colleges {
  id: any;
  value: string;
}
interface collegeBatch {
  id: any;
  value: string;
}
@Component({
  selector: 'app-student',
  templateUrl: './student.component.html',
  styleUrls: ['./student.component.scss']
})
export class StudentComponent {
  filesForm: FormGroup = this.formBuilder.group({});
  StudentList: any = [];
  closeResult = '';
  enterSearch: string = '';
  searchClose: boolean = false;
  exportButton: boolean = true;
  SortColumn: any = '';
  sortDirection: any = '';
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  showData: boolean = false;
  pageSizeOptions: number[] = [5, 10, 25, 100];
  displayedColumns: string[] = ['rowNumber', 'studentName', 'collegeName', 'batchName', 'emailId', 'mobileNo', 'isActive', 'Action'];
  dataSource: MatTableDataSource<StudentModel> = new MatTableDataSource();
  selectedCollegeValue: any;
  selectedCollegeBatchValue: any;
  @ViewChild(MatPaginator, { static: false }) paginator!: MatPaginator;
  isSubmitted: boolean = false;
  navigateFlag: boolean = false;
  studentDeleteObj:any;
  FileUpload!: File;
  submitted: boolean = false;
  CommonConstant: any = [];
  NoRecordFound: any = [];
  StudentConstant: any = [];
  studentStatusObj: any = {};
  collegeId: any = 0;
  collegeBatchId: any = 0;
  CollegeBatchList: any = [];
  CollegeList: any = [];
  protected AllCollegelist: colleges[] = this.CollegeList;
  protected AllCollegeBatchlist: collegeBatch[] = this.CollegeBatchList;
  public FilterCtrl: FormControl = new FormControl();
  public Ctrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public filteredBatchData: ReplaySubject<any> = new ReplaySubject();

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  @ViewChild('singleSelectBatch', { static: true })
  singleSelectBatch!: MatSelect;

  protected _onDestroy = new Subject();
  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  protected filterdata() {
    if (!this.AllCollegelist) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.AllCollegelist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.AllCollegelist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterBatchdata() {
    if (!this.AllCollegeBatchlist) {
      return;
    }
    let search = this.Ctrl.value;
    if (!search) {
      this.filteredBatchData.next(this.AllCollegeBatchlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBatchData.next(
      this.AllCollegeBatchlist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  //End serach singal list dropdown
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  constructor(
    private formBuilder: FormBuilder,
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private toster: ToastrService,
    private sharedService: SharedService,
    private modalService: NgbModal,
    private fileDownloadService: FileDownloadService
  ) { }

  ngOnInit(): void {
    this.filteredData.next(this.AllCollegelist.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterdata();
      });
    this.filteredBatchData.next(this.AllCollegeBatchlist.slice());
    this.Ctrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBatchdata();
      });
    this.CommonConstant = CommonConstant;
    this.NoRecordFound = NoRecordFound;
    this.StudentConstant = StudentLableConstant;
    this.getCollegeList();
    this.getStudentList();
    this.sharedService.setData('Student');
  }

  get fileFormControl() {
    return this.filesForm.controls;
  }

  getStudentList() {
    this.showData = false;
    const objData = {
      PageNumber: this.currentPage + 1,
      PageSize: this.pageSize,
      StrSearch: this.enterSearch,
      SortColumn: this.SortColumn,
      SortOrder: this.sortDirection,
      CollegeId: this.collegeId == 0 ? '' : this.collegeId.toString(),
      CollegeBatchId: this.collegeBatchId == 0 ? '' : this.collegeBatchId.toString()
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.student.GetStudentList;
    this.commonService.doPost(apiUrl, objData).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.spinner.hide();
          this.showData = true;

          let TotalRecords = 0;
          this.StudentList = response.data
          this.dataSource.data = this.StudentList;

          if (this.StudentList.length > 0) {
            TotalRecords = this.StudentList[0].totalRecords;
            this.totalRows = TotalRecords;
            this.exportButton = true;
          }
          else {
            this.exportButton = false;
          }
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = TotalRecords;
          });
        }
        else {
          this.spinner.hide();
          this.exportButton = false;
        }
      },
      error: (error) => {
        this.spinner.hide();
        this.exportButton = false;
      }
    });
  }

  pageChanged(event: { pageSize: number; pageIndex: number; }) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getStudentList();
  }

  SortChange(event: { direction: string; active: any; }) {
    this.sortDirection = event.direction == '' ? 'asc' : event.direction;
    this.SortColumn = event.active;
    this.getStudentList();
  }

  search(event) {
    if (event.target.value == '') {
      this.enterSearch = '';
      this.currentPage =0;
      this.getStudentList();
      this.searchClose = false;
    }
    else {
      this.searchClose = true;
    }
    if (event.key === "Enter" && event.target.value != '') {
      this.currentPage =0;
      this.enterSearch = event.target.value;
      this.getStudentList();
      this.searchClose = true;
    }
  }

  cancelSearch(): void {
    this.enterSearch = '';
    this.getStudentList();
    this.searchClose = false;
  }

  sanitizeInput(event: any) {
    const inputElement: HTMLInputElement = event.target;
    const sanitizedValue: string = inputElement.value.replace(/\D/g, '');
    inputElement.value = sanitizedValue;
  }

  onFileChanged(event: any) {
    let file: any;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      var extn = event.target.files[0].name.substr(
        event.target.files[0].name.lastIndexOf('.') + 1
      );
      if (extn != event.target.files[0].name) {
        var ext = event.target.files[0].name.match(/\.([^\.]+)$/)[1];
        switch (ext.toLowerCase()) {
          case 'xls':
          case 'xlsx':
          case 'csv':
            break;
          default:
            (<HTMLInputElement>document.getElementById('File')).value = '';
            this.filesForm.reset();
            this.toster.error("Please select xls,xlsx and csv files")
            return true;
        }
      } else {
        (<HTMLInputElement>document.getElementById('File')).value = '';
        this.filesForm.reset();
        return true;
      }
      reader.onload = function (e) {
        file = e.target;
      };
      reader.readAsDataURL(event.target.files[0]);
      this.FileUpload = event.target.files[0];
    } else {
    }
    return null;
  }

  resetForm() {
    this.filesForm.reset();
  }

  Upload() {
    const modalRef = this.modalService.open(DropdownDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getStudentList();
      }
    }).catch((error) => {
    });
  }

  DownloadFile() {
    this.spinner.show();
    this.fileDownloadService.downloadExcelFile();
    setTimeout(() => {
      this.spinner.hide();
    }, 1000);
  }

  onStatus(studentId: number, studentName: string, active: boolean) {
    const modalRef = this.modalService.open(StatusDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.studentStatusObj = {
      studentId: studentId,
      studentName: studentName,
      activeStudent: active
    }
    modalRef.componentInstance.studentStatusObj = this.studentStatusObj;
    modalRef.result.then((result) => {
      if (result === 'status') {
        this.StudentList.forEach((element: { studentId: number; isActive: boolean; }) => {
          if (element.studentId == studentId) {
            element.isActive = active ? false : true;
            this.getStudentList();
          }
        });
      }
    }).catch((error) => {
    });
  }

  AddStudent(studentId: number) {
    const modalRef = this.modalService.open(StudentAddComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.studentId = studentId;
    modalRef.result.then((result) => {
      if (result === 'save') {
        this.getStudentList();
      }
    }).catch((error) => {
    });
  }

  ExportStudentList() {
    const objData = {
      CollageBatchId: this.collegeBatchId == 0 ? '' : this.collegeBatchId.toString(),
      CollageId: this.collegeId == 0 ? '' : this.collegeId.toString()
    }
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.student.ExportStudent;
    this.commonService.DownloadCSVFile(apiUrl, objData).subscribe(
      (buffer) => {
        if (buffer.size != 0) {
          const data: Blob = new Blob([buffer], {
            type: "text/csv;charset=utf-8"
          });
          saveAs(data, 'Student-List.xlsx');
          this.spinner.hide();

        } else {
          this.toster.error(CommonConstant.FileNotFound);
        }
      },
      error => {
        this.spinner.hide();
        this.commonService.checkAuthorize(error);
      });
  }

  ResetCollegeSelection() {
    this.singleSelect.value = 0;
    this.singleSelectBatch.value = 0;
    this.collegeId = 0;
    this.collegeBatchId = 0;
    this.enterSearch = '';
    this.searchClose = false;
    this.getStudentList();
  }

  getCollegeList() {
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForDropDown;
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.CollegeList.push({ 'id': data.data[i].collegeId, 'value': data.data[i].collegeName })
          }
          this.filterdata();
        }
      },
      error: (err) => {
        this.toster.error(err.message);
      }
    });
  }

  onChangeCollege(e: any) {
    const matchingColleges = this.CollegeList.filter(college => college.id === e.value);
    if (matchingColleges.length > 0) {
      this.selectedCollegeValue = matchingColleges[0].value;
    }
    this.CollegeBatchList = [];
    this.collegeId = e.value;
    this.collegeBatchId = "";
    const apiUrl = this.apiUrl.apiUrl.collageBatch.GetCollegeBatchListByCollegeIdAndCompanyId.replace("{id}", this.collegeId.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.CollegeBatchList.push({ 'id': data.data[i].collegeBatchId, 'value': data.data[i].batchName })
          }
          this.AllCollegeBatchlist = this.CollegeBatchList;
          this.getStudentList();
          this.filterBatchdata();
        }
        else {
          this.AllCollegeBatchlist = [];
          this.getStudentList();
          this.filterBatchdata();
        }
      },
      error: (err) => {
        this.toster.error(err.message);
      }
    });
  }

  onChangeBatch(e: any) {
    const matchingCollegeBatch = this.CollegeBatchList.filter(college => college.id === e.value);
    if (matchingCollegeBatch.length > 0) {
      this.selectedCollegeBatchValue = matchingCollegeBatch[0].value;
    }
    this.collegeBatchId = e.value;
    this.getStudentList();
  }
  
  downloadPdf() {
    this.spinner.show();
    const url = this.apiUrl.apiUrl.student.ExportPdf;
    this.commonService.DownloadPDFFile(url).subscribe(
      (buffer: Blob) => {
        if (buffer && buffer.size > 0) {
          const blob = new Blob([buffer], { type: 'application/pdf' });
          const blobUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = blobUrl;
          a.download = `Student-List.pdf`;
          a.click();
          URL.revokeObjectURL(blobUrl);
          this.spinner.hide();
        } else {
          this.spinner.hide();
          this.toster.error(CommonConstant.FileNotFound);
        }
      },
      (error) => {
        console.error('Error:', error);
        this.spinner.hide();
      }
    );
  }

  StudentListDetail(studentId: number) {
    const modalRef = this.modalService.open(StudentViewComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.studentId = studentId;
    modalRef.result.then((result) => {
    }).catch((error) => {
    });
  }
  Deletepopup(studentId: number, studentName: string) {
    const modalRef = this.modalService.open(DeleteDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
    this.studentDeleteObj = {
      studentId: studentId,
      studentName: studentName,
      element: 'student'
    }
    modalRef.componentInstance.studentDeleteObj = this.studentDeleteObj;
    modalRef.result.then((result) => {
      if (result === 'delete') {
        this.spinner.hide();
        this.getStudentList();
      }
    }).catch((error) => {
    });
  }
}

